import { useRouter } from "next/router";
import Custom404 from "../components/ReuseableCompos/Custom404";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import DonateDetailsSidebar from "../components/ReuseableCompos/SharedDonatePages/DonateDetailsSidebar";
import useDonationSectionsMeta from "../customHooks/useDonationSectionsMeta";
import useHeaderTitleSetter from "../customHooks/useHeaderTitleSetter";

const DonateIdLayout = ({ children, singleCase }) => {
  const { selectedSectionObject } = useDonationSectionsMeta();
  const { locale } = useRouter();
  const shortName = singleCase?.contents?.short_name;
  useHeaderTitleSetter({ title: shortName });

  if (singleCase?.error || singleCase === "invalid_targetable") {
    return <Custom404 error={JSON.stringify(singleCase)} />;
  }

  return (
    <>
      <div className="sidebar-enabled sidebar-end">
        <div className="container px-0 px-lg-2">
          <div className="row gx-0 gx-lg-4">
            <div className="col-lg-9 content pt-lg-3 pt-0 mb-sm-0">
              <div className="mb-3 d-none d-lg-block">
                <CustomBreadCrumbs
                  containerClassName="mb-2"
                  transformedLabel={(title) => {
                    return title.toLocaleLowerCase() ===
                      selectedSectionObject?.page_path
                      ? selectedSectionObject?.page_metadata?.title?.[locale]
                      : shortName;
                  }}
                />
              </div>
              {children}
            </div>
            <div
              style={{ zIndex: 0 }}
              className="sidebar col-lg-3 pt-lg-4 ps-4"
            >
              <DonateDetailsSidebar />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DonateIdLayout;
